<template>
  <Fragment>
    <td>
      <px-autocomplete-cadastro-adicional
        dense
        type="CONTA_CONTABIL"
        label="Conta financeira"
        required
        class="required rounded-tag-small"
        v-model="formData.contaContabil"/>
    </td>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  components: {
    Fragment,
  },
};
</script>
